function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-13,.cls-14,.cls-2,.cls-3,.cls-5,.cls-7{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-3{stroke:#e5e5e5;}.cls-2{stroke-width:2.47px;}.cls-3{stroke-width:3.06px;}.cls-4{fill:#ed8936;}.cls-14,.cls-5{stroke:#fff;}.cls-5{stroke-width:8px;}.cls-11,.cls-6{fill:#8ce08c;}.cls-7{stroke:#2f855a;stroke-width:4.93px;}.cls-8{fill:#2f855a;}.cls-9{fill:#cbd5e0;}.cls-10{fill:#fff;}.cls-11{fill-rule:evenodd;}.cls-12{fill:#4a5568;}.cls-13{stroke:#81e6d9;stroke-width:5.14px;}.cls-14{stroke-width:2.48px;}\n"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "vector"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M591.76,97.07c67.19,71.36,95,187.14,65.66,279.73s-115.5,162-196.29,174.78-156-31-218.93-72.19S128.78,399.71,90.33,330.16,25.77,160.1,64.64,95.27,207.22,1.14,312.45,0,524.57,25.72,591.76,97.07Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 570.88,
  cy: 368.82,
  r: 162.81
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M221.46,91.35,1.53,363.29l395.74,99.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M311.17,247c110.16,3.7,116.5,210.4,103.58,231.56s-171.65,13.7-192.82-13.69S229.12,244.19,311.17,247Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-5",
  x1: 300.45,
  y1: 290.34,
  x2: 361.54,
  y2: 379.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-6",
  cx: 340.99,
  cy: 159.4,
  r: 54.65
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M337.31,154c.75-5.59-.75-10.41-3.36-10.76s-5.32,3.9-6.07,9.49.76,10.41,3.36,10.76S336.56,159.63,337.31,154Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "306.7 25.01 313.95 107.68 238.73 72.63 306.7 25.01"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: 447.25,
  y: 73.29,
  width: 64.69,
  height: 64.69,
  rx: 15.68,
  transform: "translate(0.13 -0.6) rotate(0.07)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-4",
  cx: 511.99,
  cy: 73.33,
  r: 12.55
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M475.37,91.82l-11.43,19.74a4.9,4.9,0,0,0,4.24,7.36l22.8,0a4.91,4.91,0,0,0,4.26-7.35L483.86,91.83A4.9,4.9,0,0,0,475.37,91.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M311.17,343.49a26.33,26.33,0,1,1,26.33,26.33A26.33,26.33,0,0,1,311.17,343.49Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "438.14 435.43 353.14 450.43 383.14 324.43 468.14 309.43 438.14 435.43"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "442.25 438.23 357.25 453.23 387.25 327.23 472.25 312.23 442.25 438.23"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M389.57,323.56a7.88,7.88,0,0,1-.29-2.13,8,8,0,1,1,8,8"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M413.63,319.29a8.29,8.29,0,0,1-.28-2.13,8,8,0,1,1,8,8"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M435.4,315.57a7.88,7.88,0,0,1-.29-2.13,8,8,0,1,1,8,8"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M457.93,311.31a8,8,0,1,1,7.7,5.85"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M439.3,379.93a26.33,26.33,0,1,1,26.33,26.33A26.33,26.33,0,0,1,439.3,379.93Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: 561.17,
  y: 126.34,
  width: 85.72,
  height: 104.16,
  rx: 5.32
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-10",
  cx: 577.04,
  cy: 144.16,
  r: 6.16
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 591.44,
  y1: 144.16,
  x2: 637.19,
  y2: 144.16
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-10",
  cx: 577.04,
  cy: 169.43,
  r: 6.16
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 591.44,
  y1: 169.43,
  x2: 637.19,
  y2: 169.43
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-10",
  cx: 577.04,
  cy: 194.69,
  r: 6.16
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 591.44,
  y1: 194.69,
  x2: 637.19,
  y2: 194.69
})));

var SvgWatermelonPackIllustration10 = function SvgWatermelonPackIllustration10(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 734.93 553.84",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatermelonPackIllustration10, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/watermelon-pack-illustration-10.0aab3b52.svg";
export { ForwardRef as ReactComponent };